









































interface Details {
  text: string;
  altText: string;
  desc: string;
  overlay: boolean;
  image: string;
  viewBtns: object;
  mapLayers: object;
}
import Vue, { PropType } from "vue";
import WheresMyProperty from "../HomePage/WheresMyProperty.vue";
import GoogleMap from "../HomePage/GoogleMap.vue";
export default Vue.extend({
  name: "Dialog",
  props: {
    value: { type: Boolean, default: false },
    hideDialog: { type: Function },
    details: {
      type: Object as PropType<Details>
    }
  },
  data() {
    return {
      updated: false,
      updatedTitle: null,
      updatedDesc: null,
      updatedImage: null,
      updatedViewButtons: null,
      updatedMapLayers: this.details.mapLayers
    };
  },
  components: {
    WheresMyProperty,
    GoogleMap
  },
  methods: {
    toggle(layers: object) {
      this.details.mapLayers = { ...this.details.mapLayers, ...layers };
    },
    getImage(image: string) {
      return require(`../../../public/static/ImageGallery/${image}`);
    },
    updateTitle: function(params: any) {
      // updates dialog details without mutating props
      this.updatedTitle = params;
      this.updated = true;
    },
    updateDesc: function(params: any) {
      // updates dialog details without mutating props
      this.updatedDesc = params;
      this.updated = true;
    },
    handleClick: function() {
      this.hideDialog();
      this.updated = false;
    }
  }
});
